import React from 'react'
import { AgGridReact } from "ag-grid-react";
import ModalBasic from '../../component/ModalBasic';
import TextInput from '../../../components/UIComponent/TextInput';
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const itemColdefs = [
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.09,
        flex: 0.9,
        filter: true,
    },
    {
        field: "itemType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.2,
        flex: 2,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "idwoOrderRecv",
        headerName: "ID Wo Recv",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
];


export const MaterialIssuePopup = (props) => {
    const storeToPlantColdefs = [
        {
            field: "transferNo",
            headerName: "Transfer no",
            minWidth: window.innerWidth * 0.09,
            flex: 0.9,
            filter: true,
        },
        {
            field: "itemName",
            headerName: "Item name",
            minWidth: window.innerWidth * 0.09,
            flex: 0.9,
            filter: true,
        },
        {
            field: "quantity",
            headerName: "Quantity",
            minWidth: window.innerWidth * 0.1,
            flex: 1,
            filter: true,
        },
        {
            field: "Action",
            headerName: "Action",
            minWidth: window.innerWidth * 0.05,
            flex: 0.5,
            filter: false,
            floatingFilter: false,
            cellClass: "action-col !p-0 flex items-center justify-center",
            cellRenderer: (params) => (
                <button
                    onClick={() => props.getStoreToPlantSelectedRow(params)}
                    className='edit-btn w-fit p-2.5 h-[30px] flex items-center justify-center rounded-[5px]'
                >
                    <FontAwesomeIcon icon={faArrowRight} />
                </button>
            ),
        }
    ];
    return (
        <ModalBasic
            id="material-issue"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Material issue details</span>
                <div className='item-grp grid grid-cols-6 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Issue no</label>
                        <TextInput type='text'
                            id='issueNo' name='issueNo'
                            value={props.materialObject.issueNo}
                            handleChange={(event) => props.handleChange(event, 'issueNo')}
                            className={props.validState?.error?.issueNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Issue date</label>
                        <TextInput type='date'
                            id='issueDate' name='issueDate'
                            value={props.materialObject.issueDate}
                            handleChange={(event) => props.handleChange(event, 'issueDate')}
                            className={props.validState?.error?.issueDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-3'>
                        <label>Auth. employee</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select employee"
                            options={props.materialObject.EmployeeList}
                            value={props.materialObject.idEmployee ? props.materialObject.EmployeeList.find(x => x.value === props.materialObject.idEmployee) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idEmployee", 'materialObject')
                            }
                            className={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                        /> */}
                        <TextInput type='text'
                            id='usp_Users' name='usp_Users'
                            value={props.usp_Users.find(x => x.globalUserID === props.globalUserID)?.userName || ''}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Select plant</label>
                        <MultiSelectDropdown
                            drpIdentity="Select plant"
                            options={props.materialObject.plantList}
                            value={props.materialObject.idPlant ? props.materialObject.plantList.find(x => x.value === props.materialObject.idPlant) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idPlant", 'materialObject')
                            }
                            className={props.validState?.error?.idPlant !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Issue from</label>
                        <MultiSelectDropdown
                            drpIdentity="Select issue"
                            options={props.materialObject.issueList}
                            value={props.materialObject.idIssue ? props.materialObject.issueList.find(x => x.value === props.materialObject.idIssue) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idIssue", 'materialObject')
                            }
                            className={props.validState?.error?.idIssue !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rework no</label>
                        <TextInput type='text'
                            id='reworkNo' name='reworkNo'
                            value={props.materialObject.reworkNo}
                            handleChange={(event) => props.handleChange(event, 'reworkNo')}
                            className={props.validState?.error?.reworkNo !== undefined ? "error" : ""}
                        />
                    </div>
                    {props.materialObject.idItem > 0 && (
                        <>
                            <div className='input-grp col-span-2'>
                                <label>Item Name</label>
                                <TextInput type='text'
                                    id='itemName' name='itemName'
                                    value={props.materialObject.itemName}
                                    handleChange={(event) => props.handleChange(event, 'itemName')}
                                    className={props.validState?.error?.itemName !== undefined ? "error" : ""}
                                    disabled={true}
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Qty</label>
                                <TextInput type='text'
                                    id='totalProductionQty' name='totalProductionQty'
                                    value={props.materialObject.totalProductionQty}
                                    handleChange={(event) => props.handleChange(event, 'totalProductionQty')}
                                    className={props.validState?.error?.totalProductionQty !== undefined ? "error" : ""}
                                    disabled={true}
                                />
                            </div>
                        </>
                    )}

                    <div className='btn-grp flex gap-2.5 col-span-3 col-start-1'>
                        {/* {props.materialObject.idItem > 0 && (
                            <button className="edit-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.getStoreToPlantData()}>Store to Plant</button>
                        )} */}
                        {props.materialObject.idIssue === 2 ?
                            null
                            :
                            <button className="save-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.addproduction()}>Add production details</button>
                        }
                    </div>
                </div>
                <span className="text-blue text-[16px] font-semibold">Store to plant details</span>
                <div className='item-grp grid grid-cols-6 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Transfer No</label>
                        <TextInput type='text'
                            id='transferNO' name='transferNO'
                            value={props.materialObject.transferNo}
                            handleChange={(event) => props.handleChange(event, 'transferNO')}
                            className={props.validState?.error?.transferNO !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Item Name</label>
                        <TextInput type='text'
                            id='storeToPlantItemName' name='storeToPlantItemName'
                            value={props.materialObject.storeToPlantItemName}
                            handleChange={(event) => props.handleChange(event, 'storeToPlantItemName')}
                            className={props.validState?.error?.storeToPlantItemName !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>

                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='text'
                            id='storeToPlantQty' name='storeToPlantQty'
                            value={props.materialObject.storeToPlantQty}
                            handleChange={(event) => props.handleChange(event, 'storeToPlantQty')}
                            className={props.validState?.error?.storeToPlantQty !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                </div>
                {/* {props.isStoreToPlantDetails && ( */}
                <>
                    <div className="register-table h-[14vh]">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.materialObject.storeToPlantList}
                                columnDefs={storeToPlantColdefs}
                                // onGridReady={props.onGridReady}
                                overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                            />
                        </div>
                    </div>

                </>
                {/* )} */}
                <span className="text-blue text-[16px] font-semibold">Issue item details</span>
                <div className="register-table h-[40vh]">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            onCellClicked={props.handleCellClickItemList}
                            onGridReady={props.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                    {/* <button className="print-btn btns">Print</button>
                    <button className="edit-btn btns">Preview</button> */}
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}